import { useEffect, useState } from "react";

export default function usePresenceHistory() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      const token = localStorage.getItem("membreToken");
      if (!token) return;

      const res = await fetch("/api/membre?action=history", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
      });

      const json = await res.json();
      setHistory(json.history || []);
      setLoading(false);
    }

    load();
  }, []);

  return { history, loading };
}
